import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-alert',
  styleUrls: ['dda-alert.css'],
  shadow: false,
})
export class DdaAlert {
  @Prop() type: 'primary' | 'secondary' = 'primary';
  @Prop() variation: 'info' | 'warning' | 'error' | 'success' = 'info';
  @Prop() title_text: string = '';
  @Prop() description: string = '';
  @Prop() button_text: string = '';
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() component_id?: string;

  @Prop() secondary_button?: string;
  @Prop() secondary_button_link?: string;

  @Prop() primary_button?: string;
  @Prop() primary_button_link?: string;

  
  @Prop() close_button_name?: string;

  @Event() closeClick: EventEmitter<void>;
  private onCloseClick = () => {
    this.closeClick.emit();
  };

  @Event() firstClick?: EventEmitter<void>;
   private firstClickHandler = () => {
    this.firstClick.emit();
  };

  @Event() secondClick?: EventEmitter<void>;
  private secondClickHandler = () => {
    this.secondClick.emit();
  };

  render() {
    return (
      <div class={`dda-alert dda-alert-${this.type} dda-alert-${this.variation} ${this.custom_class} ${this.component_mode}`}>
        <div class="dda-alert-inner">
          <div class="dda-alert-icon-wrap">
            <i class="info-icon material-icons material-symbols-outlined" aria-hidden="true">info</i>
          </div>
          <div class="alert-content">
            <h4 class="alert-title">{this.title_text}</h4>
            <p class="alert-description">{this.description}</p>
            <div class="alert-btn-wrap">
              {this.secondary_button ? <dda-button button_color="default-tertiary" onClick={() => this.firstClickHandler()} custom_class="alert-secondary-button" component_mode="" size="sm" button_id="button" aria_label="button" button_name="button" button_text={this.secondary_button}></dda-button> : null}
              {this.primary_button ? <dda-button button_color="default-primary" onClick={() => this.secondClickHandler()} custom_class={`alert-primary-${this.variation}`}  component_mode="" size="sm" button_id="button" aria_label="button" button_name="button" button_text={this.primary_button}></dda-button> : null}
            </div>
          </div>
        </div>

        <button type='button' name={this.close_button_name} class="dda-alert-close" onClick={this.onCloseClick}>
          <i class="material-icons material-symbols-outlined" aria-hidden="true">close</i>
        </button>
      </div>
    );
  }
}
